export var DEPLOY_DATE = new Date('2026-05-05T18:40:15+0000');
